import { useEffect, useRef } from "react";

const FACEBOOK_API_KEY = "914782201921498";
const FACEBOOK_PIXEL_URL = "https://connect.facebook.net/en_US/fbevents.js";

const initializeFacebookPixel = () => {
	/* eslint-disable */
	!function (f, b, e, v, n, t, s) {
		if (f.fbq) return; n = f.fbq = function () {
			n.callMethod ?
				n.callMethod.apply(n, arguments) : n.queue.push(arguments)
		}; if (!f._fbq) f._fbq = n;
		n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
		t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
	}(window, document, 'script', FACEBOOK_PIXEL_URL);
	fbq('init', FACEBOOK_API_KEY);

	return fbq;
	/* eslint-enable */
};

function useFacebookPixel({ location }) {
	// Initialize.
	const fbqRef = useRef();
	useEffect(() => {
		fbqRef.current = initializeFacebookPixel();
	}, []);

	// Run on every page.
	useEffect(() => {
		if (!fbqRef.current) {
			return;
		}

		fbqRef.current("track", "PageView");
	}, [fbqRef, location.pathname]);
}

export default useFacebookPixel;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useFacebookPixel.js